import React, { useState } from "react";

export default function PasswordModal({ onClose, onConfirm,username,email }) {
    console.log("username",username)
    console.log("email",email)
  const [password, setPassword] = useState("");

  const handleSubmit = async () => {
    const success = await onConfirm(password);
    if (success) {
      setPassword("");
    }
  };

  return (
    <div className="popup-overlay">
        <div className="popup-content" >
            <h2 style={{ fontSize: '20px', marginBottom: '16px', color: '#333' }}>
            Enter Password
            </h2> 
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <p style={{ margin: '4px 0', fontWeight: 600 }}>
                👤 User Name: <span style={{ fontWeight: 400 }}>{username}</span>
              </p>
              <p style={{ margin: '4px 0', fontWeight: 600 }}>
                📧 Email: <span style={{ fontWeight: 400 }}>{email}</span>
              </p>
            </div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600, fontSize: 14 }}>
                Password
            </label>
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border px-3 py-2 rounded mb-4 form-control"
                placeholder="Enter admin password"
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <button
                onClick={handleSubmit}
                style={{
                backgroundColor: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: 600,
                fontSize: "15px",
                cursor: "pointer",
                opacity: 1,
                transition: '0.2s'
                }}
            >
                Continue
            </button>
            <button
                onClick={onClose}
                style={{
                backgroundColor: "#e0e0e0",
                color: "#333",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: 600,
                fontSize: "15px",
                cursor: "pointer",
                transition: '0.2s'
                }}
            >
                Cancel
            </button>
            </div>
        </div>
    </div>
  );
}
